import type {
  FilesFileSchemaWithIdNullable,
  FilesProxySchemaWithId,
} from '@iconik-io/iconik-api/src/services/files';

import { hasGrowingStreamProxy } from './find_playable_proxy';

type LiveAssetCandidate = {
  files?: FilesFileSchemaWithIdNullable[] | null;
  proxies?: FilesProxySchemaWithId[] | null;
};

/**
 * Whether an asset is being ingested right now and can already be watched: the
 * growing file is the ingest, the growing stream proxy is what makes it watchable.
 */
export function isLiveAsset(item: LiveAssetCandidate): boolean {
  const isIngesting = (item.files ?? []).some(
    (file) => file.status === 'GROWING',
  );
  return isIngesting && hasGrowingStreamProxy(item.proxies ?? []);
}
